import { render } from "./OsdHoerverstehen.vue?vue&type=template&id=62146dcc&scoped=true"
import script from "./OsdHoerverstehen.vue?vue&type=script&lang=js"
export * from "./OsdHoerverstehen.vue?vue&type=script&lang=js"

import "./OsdHoerverstehen.vue?vue&type=style&index=0&id=62146dcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62146dcc"]])

export default __exports__